import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';

import logger from "../utils/secureLogger";
/**
 * Custom hook for handling logout with proper navigation
 */
export const useLogout = () => {
  let navigate;
  
  try {
    navigate = useNavigate();
  } catch (error) {
    // useNavigate is not available (outside Router context)
    logger.debug("⚠️ useNavigate not available, will use window.location fallback");
    navigate = null;
  }

  const { logout: storeLogout } = useAuthStore();

  const logout = async () => {
    try {
      logger.debug("🚪 useLogout: Starting logout process...");
      
      // Perform logout through store
      await storeLogout();
      
      // Navigate to login page after successful logout
      logger.debug("🔄 Navigating to login page...");
      
      if (navigate) {
        // Use React Router navigation if available
        navigate('/login', { replace: true });
      } else {
        // Fallback to window.location if Router is not available
        logger.debug("🔄 Using window.location fallback");
        window.location.href = '/login';
      }
      
    } catch (error) {
      logger.error("❌ useLogout: Logout error:", error);
      
      // Even if logout fails, navigate to login for security
      if (navigate) {
        navigate('/login', { replace: true });
      } else {
        window.location.href = '/login';
      }
    }
  };

  // Export both names for compatibility
  return { 
    logout,
    handleLogout: logout // Alias for backward compatibility
  };
};

export default useLogout;
